import { jsx as _jsx } from "react/jsx-runtime";
import { AwaitModules, ComponentSync } from '@nu-art/thunderstorm-frontend';
import { Component_AdvisorSL_InboxItems } from '../../../loaders/skeleton/index.js';
import { InboxFilters_LabelMap, InboxItemType_Order, orderStatusMatchesInboxFilter } from '@app/advisor-v5-shared';
import { ModuleFE_Advisor_Action, ModuleFE_Advisor_Resource, ModuleFE_EMInterface, ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { ModuleFE_Inbox } from '../../../../modules/module-inbox/ModuleFE_Inbox.js';
import { sortArray } from '@nu-art/ts-common';
import { RuntimeOrderStatus_Enum } from '@app/advisor-shared';
import { Component_InboxItem_Order } from '../../inbox-item/Component_InboxItem_Order.js';
import { ModuleFE_ScrollBar } from '@app/styles/frontend/modules/ModuleFE_ScrollBar/ModuleFE_ScrollBar';
import './Component_Inbox.scss';
import { FadeScrollWrapper } from '@app/styles';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
const modulesToAwait = [
    //Static Modules
    ModuleFE_Advisor_Action, //For the DB orders
    ModuleFE_Advisor_Resource, //For order icon rendering
    //Runtime Modules
    ModuleFE_RuntimeOrder, //For the actual orders
];
class Component_Inbox_Class extends ComponentSync {
    //######################### Life Cycle #########################
    __onReadOnlyChanged() {
        this.setState({ readonly: ModuleFE_EMInterface.isReadonly() });
    }
    __onInboxFiltersUpdated = () => {
        const inboxFilters = ModuleFE_Inbox.activeFilters.get();
        this.setState({ inboxFilters }, () => {
            ModuleFE_AdvisorAnalytics.trigger.inbox.inbox_filter({
                filterLabels: inboxFilters.map(filter => InboxFilters_LabelMap[filter]),
                resultCount: this.state.inboxItems.filter(this.inboxItemPassesFilter).length,
            });
            setTimeout(() => {
                if (this.props.scrollRef)
                    ModuleFE_ScrollBar.updateScrollBar(this.props.scrollRef);
            }, 100);
        });
    };
    __onRuntimeOrdersUpdated() {
        const inboxItems = this.resolveOrderInboxItems();
        this.setState({ inboxItems });
    }
    __onRuntimeProtocolsUpdated() {
        const inboxItems = this.resolveOrderInboxItems();
        this.setState({ inboxItems });
    }
    deriveStateFromProps(nextProps, state) {
        state.inboxItems ??= this.resolveOrderInboxItems();
        state.readonly ??= ModuleFE_EMInterface.isReadonly();
        state.inboxFilters ??= ModuleFE_Inbox.activeFilters.get();
        return state;
    }
    componentDidMount() {
        ModuleFE_AdvisorAnalytics.trigger.uiLoad.uiLoad_inbox({
            elapsed_ms: ModuleFE_AdvisorAnalytics.getTimeSinceLoad(),
        });
    }
    //######################### Logic #########################
    resolveOrderInboxItems() {
        return sortArray(ModuleFE_RuntimeOrder.cache.filter(order => !order.extraMetadata?.rejected && order.orderStatus !== RuntimeOrderStatus_Enum.RECOMMENDED), item => item.timeResulted ?? item.timeCreated ?? item.__created // when order is being added it being created in pending status so there's no accept time
        , true).map(order => ({
            type: InboxItemType_Order,
            item: order
        }));
    }
    inboxItemPassesFilter = (inboxItem) => {
        switch (inboxItem.type) {
            case InboxItemType_Order: {
                const item = inboxItem;
                const status = item.item.orderStatus;
                return orderStatusMatchesInboxFilter(status, this.state.inboxFilters);
            }
            default:
                return false;
            //Keeping legacy code in-case they bring these inbox item types back
            // case InboxItemType_Wizard: {
            // 	const item = inboxItem as UIInboxItem<typeof InboxItemType_Wizard>;
            // 	const status = item.item.status;
            // 	return wizardStatusMatchesInboxFilter(status, filters);
            // }
            // case InboxItemType_DataNeeded: {
            // 	return !filters.length || filters.includes(InboxFilter_InputRequired);
            // }
        }
    };
    //######################### Render #########################
    render() {
        if (!this.state.inboxItems.length)
            return _jsx("div", { className: 'c__inbox message', children: "No tests were ordered yet" });
        const filteredItems = this.state.inboxItems.filter(this.inboxItemPassesFilter);
        if (!filteredItems.length)
            return _jsx("div", { className: 'c__inbox message', children: "No orders to show for current filter" });
        return _jsx(FadeScrollWrapper, { className: 'c__inbox', scrollRef: this.props.scrollRef, children: filteredItems.map((item => {
                switch (item.type) {
                    case InboxItemType_Order:
                        return _jsx(Component_InboxItem_Order, { disabled: this.state.readonly, rtOrder: item.item }, item.item._id);
                    default:
                        return;
                }
            })) });
    }
}
export const Component_Inbox = (p) => _jsx(AwaitModules, { modules: modulesToAwait, Component: () => _jsx(Component_Inbox_Class, { ...p }), customLoader: Component_AdvisorSL_InboxItems });
//# sourceMappingURL=Component_Inbox.js.map